import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
    selector: '[spanTitleIfOverflow]',
    standalone: false
})
export class TitleIfOverflowDirective implements AfterViewInit, OnDestroy {
   private observer!: ResizeObserver;

   constructor(private el: ElementRef, private renderer: Renderer2) {}

   ngAfterViewInit() {
      const element = this.el.nativeElement;

      this.observer = new ResizeObserver(() => {
         this.applyTitle();
      });
      this.observer.observe(element);

      requestAnimationFrame(() => this.applyTitle());
   }

   ngOnDestroy() {
      this.observer?.disconnect();
   }

   private applyTitle() {
      const element = this.el.nativeElement;
      const text = element.textContent?.trim() || '';

      if (element.scrollWidth > element.clientWidth && text) {
         this.renderer.setAttribute(element, 'title', text);
      } else {
         this.renderer.removeAttribute(element, 'title');
      }
   }
}
